import styled from "styled-components"

export const GridStyled = styled.div`
  padding: 0.5rem;
  font-family: MontserratRegular;
`

export const RowsSelectPanel = styled.div`
  width: 100%;
  text-align: right;
  margin: 0.5rem;
  font-size: 1.2rem;
  padding: 1rem 3rem;

  select {
    cursor: pointer;
    width: 5.5rem;
    height: 2rem;
    background: #FFFFFFE6 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #707070;
    border-radius: 58px;
    text-align: center;
    vertical-align: center;
  }
`

export const ActionsPanel = styled.div`
  width: 100%;
  text-align: left;
  margin: 0.5rem;
  font-size: 1rem;
  padding: 0.5rem 4.5rem;
`

export const TablePanel = styled.div`
  display: block;
  position: relative;
  height: 100%;
  padding: 0 4.5rem;
`

export const TableContainer = styled.div`
  display: block;
  position: relative;
  width: 100%;
  overflow-x: auto;
  
  table {
    width: 100%;
    display: table;
    font-size: 1rem;
    position: relative;
    max-height: 500px;
    
    tr {
      font-size: 1.2rem;
      
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
        
    th,
    td {
      border: 2px solid #9C949480;
      text-align: center;
      vertical-align: middle;
      padding: 0.2rem;
      height: 1rem;

      :last-child {
        align-items: center;
      }
    }

    .cellNoBorder {
      border: 0;
      width: 4rem;
      
    }

    .content-button {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

  }
`

interface PaginationPanel {
  bg?: string
}

export const PaginationPanel = styled.div`
  width: 100%;
  height: fit-content;
  border: 2px solid #9C949480;
  font-size: 1.2rem;
  margin-bottom: 4rem;
  padding: 0;

  button { 
    cursor: pointer;
    width: 25%;
    height: 2.6rem;
    display: block;
    background-color: gray;
    border: none;
    color: #FFFFFFE6;
  }

  .pagesCount {
    width: 50%;
    height: 2.6rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`

export const InputFilter = styled.input`
  width: 90%;
  height: 1.7rem;
  font-size: 1rem;
  background: #FFFFFFE6 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #707070;
  border-radius: 58px;
  padding: 0 1rem;
`

export const SelectFilter = styled.select`
  width: 90%;
  height: 1.7rem;
  cursor: pointer;
  font-size: 1rem;
  background: #FFFFFFE6 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #707070;
  border-radius: 58px;
  padding: 0 1rem;
`

interface TableButton {
  color?: string
  visible?: boolean
}

export const TableButton = styled.a`
  background-color: ${(p: TableButton) => p.color};
  border: 0;
  color: white;
  width: 100%;
  height: 2rem;
  display: ${(p: TableButton) => (p.visible) ? "flex" : "none"};
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:hover {
    background: transparent;
    border: 2px solid ${(p: TableButton) => p.color};
    cursor: pointer;
    color: ${(p: TableButton) => p.color};
  }
`